export default function getEnv(name: string) {
  const windowAny = window as Window & { configs?: Record<string, string> };
  return windowAny?.configs?.[name] || process.env[name];
}
